// Same viewport-edge clamp convention as this directory's other portaled-UI
// position calculators (floatingToolbarPosition.ts, mentionDropdownPosition.ts).
const VIEWPORT_MARGIN_PX = 8;

/**
 * The shell is an in-flow child of a horizontally scrolling
 * canvas on the fixed-width page, so its rect moves by −scrollLeft; adding
 * the host's scrollLeft back anchors the panel to the UNscrolled right edge
 * (= the canvas's visible right edge, the shell being exactly the canvas's
 * clientWidth wide); scrollLeft is 0 on every fluid surface. The 44 / 12
 * literals are moved verbatim from FindReplacePanel.tsx.
 */
export function computeFindPanelPosition(
    shellRect: { top: number; right: number },
    hostScrollLeft: number,
    viewportWidth: number,
): { top: number; right: number } {
    return {
        top: Math.max(VIEWPORT_MARGIN_PX, shellRect.top + 44), // clears the toolbar; clamps into the viewport when scrolled
        right: Math.max(VIEWPORT_MARGIN_PX, viewportWidth - (shellRect.right + hostScrollLeft) + 12),
    };
}
